import React, { useState } from 'react'
import { getWallboardToken, clearWallboardToken } from './wallboardToken'
import WallboardPage from './WallboardPage'
import WallboardUnlock from './WallboardUnlock'

// Public /wallboard entry (no session): with a stored device token the
// display runs; without one (or after a revoke) the admin unlock screen
// shows. Locking a display clears its token.
const WallboardGate = () => {
  const [unlocked, setUnlocked] = useState(() => !!getWallboardToken())

  if (!unlocked) {
    return <WallboardUnlock onUnlocked={() => setUnlocked(true)} />
  }

  return (
    <WallboardPage
      mode="device"
      onExit={() => {
        clearWallboardToken()
        setUnlocked(false)
      }}
    />
  )
}

export default WallboardGate
